import { render, staticRenderFns } from "./GdprModal.vue?vue&type=template&id=d54932b6"
import script from "./GdprModal.vue?vue&type=script&lang=js"
export * from "./GdprModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports